import { useTranslation } from 'libs/i18n';

import {
  OrderSubmissionContactsFormType,
  FormErrors,
  getSchema,
} from '../../forms/orderSubmissionContacts';
import { ClientType, FormBodyWrapper } from '../FormBodyWrapper';

import { FormContent } from './FormContent';

interface Props {
  initialValues?: OrderSubmissionContactsFormType;
  onSubmit: (values: OrderSubmissionContactsFormType) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  formError?: FormErrors;
  submitLoading?: boolean;
  clientType?: ClientType;
}

export const OrderSubmissionContacts = ({
  initialValues,
  canGoBack,
  onGoBack,
  submitLoading,
  formError,
  onSubmit,
  clientType,
  ...formProps
}: Props) => {
  const { t } = useTranslation();
  const schema = getSchema(t);
  return (
    <FormBodyWrapper
      canGoBack={canGoBack}
      clientType={clientType}
      initialErrors={formError}
      initialValues={initialValues}
      submitLoading={submitLoading}
      subTitle={t('onboarding.orderSubmissionContacts.subtitle')}
      title={t('onboarding.orderSubmissionContacts.title')}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <FormContent {...formProps} />
    </FormBodyWrapper>
  );
};
